import AceHighwayShipmentApiUrls from 'src/apiUrls/AceHighwayShipmentApiUrls'
import FormProperties from './FormProperties'
import { Grid } from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import { components, useServices } from 'cng-web-lib'
import pathMap from 'src/paths/pathMap'
import { useLocation } from "react-router-dom";
import { useFormContext } from 'react-hook-form'
import Sec321AmountExceededDialog from '../manifest/shipment/Sec321AmountExceededDialog'
import ACEHighwayShipmentTranslationText from '../contexts/ACEHighwayShipmentTranslationText'

const {
  button: { CngButton },
  form: { CngAddForm }
} = components

function AddPage({ history, showNotification, onSetLoading }) {
  const { securedSendRequest, createRecord } = useServices()
  const loc = useLocation()
  const dataRef = useRef()
  const [sec321AmountExceededDialog, setSec321AmountExceededDialog] = useState({ open: false, shipments: [], manifestId: null })
  const aceHighwayShipmentTranslationText = ACEHighwayShipmentTranslationText()

  let formikPropsData;
  let  manifestId;
  if(loc.state !== undefined) {
    formikPropsData = {
          ...FormProperties.formikProps,
          initialValues: FormProperties.toClientDataFormat(loc.state)     
    }
    manifestId=loc.state.manifestId;
  } else {
    formikPropsData = FormProperties.formikProps
  }

  function preCreateShipment() {
    onSetLoading(true)
    if (manifestId != '' && manifestId != undefined) {
    let shipments = [dataRef.current]
      securedSendRequest.execute('POST', AceHighwayShipmentApiUrls.VALIDATE_SEC321_AMOUNT, shipments,
        (response) => {
          const messages = response.data
          if (messages.length > 0) {
            setSec321AmountExceededDialog({ open: true, shipments: shipments, manifestId: null, messages: messages, isView: false })
            onSetLoading(false)
          } else {
            handleCreateShipment()
          }
        })
    } else {
      handleCreateShipment()
    }
  }

  function handleCreateShipment() {
    onSetLoading(true)
    let shipment = FormProperties.toServerDataFormat(dataRef.current)
    createRecord.execute(
      AceHighwayShipmentApiUrls.POST, 
      shipment,
      (response) => {
        showNotification('success', aceHighwayShipmentTranslationText.createdSuccessfully)
        if (manifestId != '' && manifestId != undefined) {
          history.push({ pathname: `${pathMap.ACE_HIGHWAY_MANIFEST}/edit/` + manifestId, activeTabIndex: 1 })
        } else {
          history.push({ pathname: pathMap.ACE_HIGHWAY_SHIPMENT_LIST_VIEW })
        }
      },
      (error) => {
        let  errorResponse = error.response;
          if(errorResponse.status == 403){
            if(errorResponse.data){
              showNotification('error', errorResponse.data.errorMessages)
            }
          }
        console.log(error)
      }
    ).finally(() => {
      onSetLoading(false)
    })
  }

  return (
    <>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CngAddForm
          fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
          history={history}
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap, shouldDisableMap) => (
            <FormProperties.Fields
              disabled={false}
              showNotification={showNotification}
              shouldHideMap={shouldHideMap} />
          )}
          formikProps={formikPropsData}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          renderButtonSection={(loading) => (
            <CustomButtonSection
              history={history}
              loading={loading}
              onSetLoading={onSetLoading}
              onCreateShipment={(data) => {
                dataRef.current = data
                preCreateShipment()
              } } />
          )} />
      </Grid>
    </Grid>
    <Sec321AmountExceededDialog
        onClose={() => setSec321AmountExceededDialog({ open: false, shipments: [], data: null, messages: [] })}
        onSubmit={handleCreateShipment}
        open={sec321AmountExceededDialog.open}
        shipments={sec321AmountExceededDialog.shipments}
        shipment={sec321AmountExceededDialog.shipment}
        data={sec321AmountExceededDialog.data}
        messages={sec321AmountExceededDialog.messages} />
      </>  
  )
}

export default AddPage

function CustomButtonSection(props) {
  const { history, loading, onSetLoading, onCreateShipment } = props
  const { getValues, trigger } = useFormContext()
  const aceHighwayShipmentTranslationText = ACEHighwayShipmentTranslationText()

  useEffect(() => {
    onSetLoading(loading)
  }, [loading])

  return (
    <Grid container justify='space-between' spacing={3}>
      <Grid item xs='auto'>
        <CngButton
          color='secondary'
          disabled={loading}
          onClick={() => history.push(pathMap.ACE_HIGHWAY_SHIPMENT_LIST_VIEW)}
          size='medium'
        >
          {aceHighwayShipmentTranslationText.discardButton}
        </CngButton>
      </Grid>
      <Grid item xs='auto'>
        <CngButton
          color='primary'
          disabled={loading}
          size='medium'
          shouldShowProgress={loading}
          onClick={async () => {
            let result = await trigger()
            if (result) {
              onCreateShipment(getValues())
            }
          }}
        >
          {aceHighwayShipmentTranslationText.saveButton}
        </CngButton>
      </Grid>
    </Grid>
  )
}
